import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

const metersApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getMeters: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `meters${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('Meter'),
        }),
        getMeter: build.query({
            query: (id) => {
                return {
                    url: `meters/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Meter', result),
        }),
        deleteMeter: build.mutation({
            query: (id) => {
                return {
                    url: `meters/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Meter'],
        }),
        createMeter: build.mutation({
            query: (data) => {
                return {
                    url: `meters`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Meter'],
        }),
        editMeter: build.mutation({
            query: (data) => {
                return {
                    url: `meters/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Meter'],
        }),
        syncMeter: build.mutation({
            query: (id) => {
                return {
                    url: `meters/${id}/sync`,
                    method: 'POST',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Meter'],
        }),
        syncZeusintDaily: build.mutation({
            query: () => ({
                url: `meters/sync/zeusint/daily`,
                method: 'POST',
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['MeterReading'],
        }),
    }),
    overrideExisting: false,
})

export default metersApi

export const {
    useGetMetersQuery,
    useGetMeterQuery,
    useDeleteMeterMutation,
    useCreateMeterMutation,
    useEditMeterMutation,
    useSyncMeterMutation,
    useSyncZeusintDailyMutation,
} = metersApi
